export const PAGE_HOME_PATH = '/';
export const PAGE_POOLS_PATH = '/pools';
export const PAGE_PRIVACY_PATH = '/privacy';
export const PAGE_TERMS_PATH = '/terms';
export const PAGE_LANDING_PATH = '/landing';
